import { useEffect, useMemo } from 'react';
import { Comment } from 'jamespot-front-business';
import socket from '../utils/socket';
import { useAppDispatch } from '../redux/store';

const useCommentRT = (idArticle: number) => {
    const dispatch = useAppDispatch();
    const reactSocket = useMemo(() => socket, []);
    const rtHandlers = useMemo(() => Comment.getCommentRTHandlers(dispatch, idArticle), [dispatch, idArticle]);

    useEffect(() => {
        rtHandlers.forEach((handler) => {
            reactSocket.onMessage(handler.namespace, handler.function, handler.handler);
        });
        return () => {
            rtHandlers.forEach((handler) => {
                reactSocket.offMessage(handler.namespace, handler.function, handler.handler);
            });
        };
    }, [rtHandlers, reactSocket]);
};

export default useCommentRT;
